import type { Experiments, ViewMode, ViewerModel } from '@wix/thunderbolt-symbols'
import type { EnvironmentServiceEditorConfig, EnvironmentServiceSiteConfig } from './types'
import type { IEnvironmentServiceConfig } from '@wix/viewer-service-environment/definition'

export const getServiceConfig = (
	featureConfig: EnvironmentServiceSiteConfig | EnvironmentServiceEditorConfig,
	viewerModel: ViewerModel,
	siteLanguage: string,
	viewMode: ViewMode
): IEnvironmentServiceConfig => {
	const {
		localesInfo: _localesInfo,
		platformAppsExperiments: _platformAppsExperiments,
		...environmentFeatureConfig
	} = featureConfig

	return {
		...environmentFeatureConfig,
		editorType: featureConfig.editorType as IEnvironmentServiceConfig['editorType'],
		requestUrl: viewerModel?.requestUrl,
		isQaMode: viewerModel?.mode.qa,
		viewMode,
		editorName: viewerModel?.site.editorName,
		deviceType: viewerModel?.deviceInfo.deviceClass,
		language: siteLanguage as IEnvironmentServiceConfig['language'],
	}
}

export const mergeAppsExperiments = (
	experiments: Experiments,
	platformAppsExperiments: EnvironmentServiceSiteConfig['platformAppsExperiments']
): Experiments => {
	const flatAppExperiments = Object.values(platformAppsExperiments ?? {}).reduce(
		(acc, appExps) => ({ ...acc, ...appExps }),
		{} as Record<string, string>
	)
	return { ...flatAppExperiments, ...experiments }
}
